import {makeApiRequest} from './api';
import {UnitSystem} from './series';

export type BoxplotStats = {
  min: number;
  q25: number;
  median: number;
  q75: number;
  max: number;
  outliers: number[];
};

export type SWEAnalysisResponse = {
  /** Date (YYYY-MM-DD) of the SWANN field the current values come from */
  observedDate?: string;
  volumeUnit: string;
  elevationUnit: string;
  spatialCoverage: number;
  elevationBandBoxplot: {
    bands: string[];
    stats: BoxplotStats[];
    currentValues: (number | null)[];
    yearRange: [number, number];
    numYears: number;
  };
  annualLines: {
    bands: string[];
    years: Array<{year: number; values: (number | null)[]}>;
    current: {year: number; values: (number | null)[]};
    highlighted: {
      lowYears: number[];
      highYears: number[];
      previousYears: number[];
    };
  };
  elevationProfile: {
    bandEdges: number[];
    current: (number | null)[];
    climatology: (number | null)[];
    summary: {
      totalCurrent: number;
      totalClimatology: number;
      percentOfHistoricalAvg: number | null;
    };
  };
};

export type AvailableAnalyses = {
  sweAnalysis: boolean;
};

export async function fetchAvailableAnalyses(
  siteId: string,
  projectId: string
): Promise<AvailableAnalyses> {
  const response = await makeApiRequest<AvailableAnalyses>(
    'api/v2/hydroforecast/analysis/available',
    {siteId, projectId}
  );
  return response.data;
}

export async function fetchSWEAnalysis(
  siteId: string,
  projectId: string,
  unitSystem: UnitSystem
): Promise<SWEAnalysisResponse> {
  const response = await makeApiRequest<SWEAnalysisResponse>(
    'api/v2/hydroforecast/analysis/sweAnalysis',
    null,
    {
      method: 'POST',
      body: JSON.stringify({siteId, projectId, unitSystem}),
    }
  );
  if (response.error) {
    throw new Error(response.error);
  }
  return response.data;
}
